import { granularity } from "@/settings/charts/settingsDictionary";
import yearOverYearLineChart from "@/settings/charts/yearOverYearLineChart";
import { FAMILY } from "@/settings/widgetFamilies";
import { Config } from "@/types/charts";

export default <Config>{
  family: [FAMILY.OVERTIME],
  name: "yearOverYearStepLineChart",
  title: "Year Over Year Step Line Chart",
  defaultHeight: 6,
  controls: [granularity],
  settings: yearOverYearLineChart.settings,
  planSettings: yearOverYearLineChart.planSettings,
  planExploreSettings: yearOverYearLineChart.planExploreSettings,
};
